import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

/// 404 Not Found ページコンポーネント
const NotFoundPage: React.FC = () => {
  useEffect(() => {
    // ページタイトルを設定
    document.title = 'ページが見つかりません - マールの保管庫';
    
    // ページ表示時にbodyクラスを追加
    document.body.classList.add('not-found-page-body');

    // クリーンアップ：ページ離脱時にbodyクラスを削除
    return () => {
      document.body.classList.remove('not-found-page-body');
      document.title = 'マールの保管庫 - 非公式ファンサイト';
    };
  }, []);

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <div className="not-found-content">
          {/* エラーアイコンとコード */}
          <div className="not-found-icon">
            <span className="error-code">404</span>
            <span className="error-emoji">😵</span>
          </div>
          
          {/* エラーメッセージ */}
          <div className="not-found-message">
            <h1 className="not-found-title">ページが見つかりません</h1>
            <p className="not-found-description">
              お探しのページは存在しないか、移動した可能性があります。
              <br />
              URLをご確認の上、もう一度お試しください。
            </p>
          </div>
          
          {/* アクションボタン */}
          <div className="not-found-actions">
            <Link to="/" className="action-button primary">
              <span className="button-icon">🏠</span>
              <span>トップページへ戻る</span>
            </Link>
            
            <Link to="/search" className="action-button secondary">
              <span className="button-icon">🔍</span>
              <span>動画を検索する</span>
            </Link>
            
            <button 
              onClick={() => window.history.back()} 
              className="action-button tertiary"
            >
              <span className="button-icon">←</span>
              <span>前のページに戻る</span>
            </button>
          </div>
          
          {/* 人気コンテンツへのリンク */}
          <div className="not-found-suggestions">
            <h3 className="suggestions-title">おすすめのページ</h3>
            <div className="suggestions-grid">
              <Link to="/links" className="suggestion-card">
                <span className="suggestion-icon">🔗</span>
                <span className="suggestion-text">外部リンク集</span>
              </Link>
              
              <Link to="/watch-together" className="suggestion-card">
                <span className="suggestion-icon">👥</span>
                <span className="suggestion-text">みんなで視聴</span>
              </Link>
            </div>
          </div>
          
          {/* マール・アストレアキャラクター */}
          <div className="not-found-character">
            <img 
              src="/assets/images/icon/marle_icon.jpg" 
              alt="マール・アストレア" 
              className="character-image"
              onError={(e) => {
                // 画像が見つからない場合は非表示
                e.currentTarget.style.display = 'none';
              }}
            />
            <div className="character-speech">
              <p>「迷子になっちゃったみたい...💦」</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage; 